// extracted by mini-css-extract-plugin
export default {"mainContainer":"Link_mainContainer__7BNfc"};